import React from "react";

const StadiumSharedGlobalConfigContext = React.createContext({});

const { Provider } = StadiumSharedGlobalConfigContext;

const StadiumSharedConfigWrapper = ({ value, children }) => (
  <Provider value={value}>{children}</Provider>
);

export { StadiumSharedConfigWrapper, StadiumSharedGlobalConfigContext };
